//#region Angular Imports

import { StateProvider, StateService } from '@uirouter/angularjs'
import 'angular-gridster'

//#endregion

import { Enums } from '../../models/common/enums'
import { Activity } from '../../models/common/activity'
import { UserSession } from '../../helpers/user-session'

import { default as commonModule, LoggerService } from './../common/common.module'
import { default as apiModule, Api, LocalDictionaryFactory } from './../api/api.module'

import { MenuItem } from '../common/sidebar-menu/common.sidebar-menu.directive'

import { DeviceConnectionsController } from './deviceconnections.controller'
import { ConfigHelper } from '../../helpers/config-helper';
import { OpOperator } from '../../models/core/op-operator';

import { $SCOPE_SERVICE_NAME, $STATE_SERVICE_NAME, $TIMEOUT_SERVICE_NAME, SYSTEM_SERVICE_NAME, SystemService } from '../../services/system'
import { GRID_CONTEXT_MENU_SERVICE_NAME, GridContextMenuService } from '../../services/grid'
import { USER_SESSION_SERVICE_NAME, UserSessionService } from '../../services/user-session'

//#region Asset Imports

import './deviceconnections.scss'
import * as TEMPLATE from './deviceconnections.tpl.html'

//#endregion

// Consts

const simaxModuleName: Enums.SimaxModuleName = Enums.SimaxModuleName.Device_Connection
const referenceType: Enums.ReferenceType = Enums.ReferenceType.IdDeviceConnection

const CONTROLER_NAME: string = 'DeviceConnectionsController'
const MODULE_NAME: string = 'simax.deviceconnections'
const MODULE_NAME_LOCALIZATION_TEXT: string = 'DeviceConnections'
const MENU_INDEX: number = 14
const STATE_NAME: string = 'deviceconnections'
const STATE_URL: string = '/deviceconnections'

// Consts End

// Setup

const module = angular.module(MODULE_NAME, [commonModule, apiModule, 'gridster'])

module.controller(CONTROLER_NAME, [
    $SCOPE_SERVICE_NAME,
    $STATE_SERVICE_NAME,
    $TIMEOUT_SERVICE_NAME,
    'api',
    'logger',
    'localDictionary',
    GRID_CONTEXT_MENU_SERVICE_NAME,
    USER_SESSION_SERVICE_NAME,
    SYSTEM_SERVICE_NAME,
    (
        $scope,
        $state: StateService,
        $timeout,
        api: Api,
        logger: LoggerService,
        localDictionary: LocalDictionaryFactory,
        gridContextMenuService: GridContextMenuService,
        userSession: UserSessionService,
        systemService: SystemService
    ) => new DeviceConnectionsController(
        $scope,
        $state,
        $timeout,
        api,
        logger,
        localDictionary,
        gridContextMenuService,
        userSession,
        systemService,
        referenceType,
        simaxModuleName
    )])

module.config(["$stateProvider", 'userSessionProvider', ($stateProvider: StateProvider, userSessionProvider: UserSession) => {
    userSessionProvider.getLoggedOperatorAsync().then((loggedOperator: OpOperator) => {
        if (loggedOperator.hasPermission(Activity.DEVICE_CONNECTION_LIST)
            && !loggedOperator.hasPermission(Activity.DEVICE_CONNECTION_MODULE_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.DeviceConnectionModule)) {
            MenuItem.addMenuItem(ConfigHelper.getIconName(ConfigHelper.Icon.DEVICE_CONNECTIONS),
                'deviceconnections',
                MODULE_NAME_LOCALIZATION_TEXT,
                STATE_NAME,
                MENU_INDEX
            )
            $stateProvider.state(STATE_NAME, {
                url: STATE_URL,
                controller: CONTROLER_NAME,
                template: TEMPLATE,
                params: { ids: null }
            })
        }
    })
}])

// Setup End
export default MODULE_NAME